import { render, staticRenderFns } from "./AllHouseProduct.vue?vue&type=template&id=a6b371be&scoped=true&"
import script from "./AllHouseProduct.vue?vue&type=script&lang=js&"
export * from "./AllHouseProduct.vue?vue&type=script&lang=js&"
import style0 from "./AllHouseProduct.vue?vue&type=style&index=0&id=a6b371be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b371be",
  null
  
)

component.options.__file = "AllHouseProduct.vue"
export default component.exports